import React from 'react';
import { Users, Zap, FileText, FileCheck, ShieldCheck, PlayCircle, ArrowRight } from 'lucide-react';
export const ProductWorkflow = () => {
  const steps = [{
    number: '01',
    title: 'Agencies list their roster',
    desc: 'Talent agencies add their creators to the database so they are discoverable.',
    icon: <Users size={24} className="text-zano-pink" data-id="element-1842" data-mp="jl11p14j49m" />
  }, {
    number: '02',
    title: 'Profiles stay current',
    desc: 'Zano updates live performance data (followers, views, engagement) automatically.',
    icon: <Zap size={24} className="text-blue-500" data-id="element-1843" data-mp="341upo15u44g9" />
  }, {
    number: '03',
    title: 'Brands post casting calls',
    desc: 'Specify goals, deliverables, and budget. Blasted to 400+ agencies instantly.',
    icon: <FileText size={24} className="text-purple-500" data-id="element-1844" data-mp="x8iw78csd47b" />
  }, {
    number: '04',
    title: 'Agencies submit talent',
    desc: 'Agencies review the brief and submit their best-fit creators with custom quotes.',
    icon: <FileCheck size={24} className="text-orange-500" data-id="element-1845" data-mp="wo66c21wg41h" />
  }, {
    number: '05',
    title: 'Connect directly',
    desc: 'Filter submissions, find the right match, and take the conversation directly to email.',
    icon: <PlayCircle size={24} className="text-green-500" data-id="element-1846" data-mp="15nje8qadkkk3" />
  }];
  return <section className="py-24 bg-white border-y border-gray-100" data-id="element-1847" data-mp="1ao77lim2tdhh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1848" data-mp="d1qbggp2x5xb">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1849" data-mp="cz45umlr10hq">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1850" data-mp="i0l1o3pdlwrg">
            How Zano works
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1851" data-mp="mx1psxwksb4j">
            Streamlining how you source represented talent and partner with
            talent agencies at scale.
          </p>
        </div>

        <div className="relative" data-id="element-1852" data-mp="3qflanfcxcepb">
          {/* Connecting Line */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-100 -z-10" data-id="element-1853" data-mp="3vdwk3ozb4n70"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-1854" data-mp="3ncxiig80ewh1">
            {steps.map((step, idx) => <div key={idx} className="relative flex flex-col items-center text-center" data-id="element-1855" data-mp="3jakepxctp8mw" data-mpi={idx}>
                <div className="w-24 h-24 bg-white rounded-full border-4 border-zano-blush shadow-sm flex items-center justify-center mb-6 relative z-10" data-id="element-1856" data-mp="3s4gp6ewmkwmh">
                  <div className="absolute top-0 right-0 w-6 h-6 bg-zano-pink text-white text-xs font-bold rounded-full flex items-center justify-center transform translate-x-1 -translate-y-1" data-id="element-1857" data-mp="34hgwrovbksvn">
                    {step.number}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-3" data-id="element-1858" data-mp="39gk4xi6ljf7u">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-1859" data-mp="ooi9avbvfp3o">
                  {step.desc}
                </p>

                {idx < steps.length - 1 && <div className="hidden md:block lg:hidden absolute top-12 -right-4 text-gray-300" data-id="element-1860" data-mp="26nzg9uf914x4">
                    <ArrowRight size={24} data-id="element-1861" data-mp="2bivan17yk4de" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};